import axios from 'axios';

export default class RegistrationServiceApi {
	/**
	 * Get register user
	 */
	static async userRegistered(email) {
		const jwtServiceEndpoint = {
			baseURL: window.ENV.BENEFICIARY_SERVICE_BASE_URL,
			url: '/user-registered',
			data: email,
			timeout: 10000,
			method: 'post',
			mode: 'cors',
			responseType: 'json',
			headers: {
				Accept: 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
			}
		};
		try {
			return await axios.request(jwtServiceEndpoint);
		} catch (error) {
			if (error.response) {
				return error.response;
			} else {
				return error;
			}
		}
	}

	static async userDeleted(email, token) {
		const jwtServiceEndpoint = {
			baseURL: window.ENV.BENEFICIARY_SERVICE_BASE_URL,
			url: '/remove-user',
			data: email,
			timeout: 10000,
			method: 'delete',
			mode: 'cors',
			responseType: 'json',
			headers: {
				Accept: 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				jwt: token
			}
		};
		try {
			return await axios.request(jwtServiceEndpoint);
		} catch (error) {
			if (error.response) {
				return error.response;
			} else {
				return error;
			}
		}
	}

	static async pingRegistrationApi(email) {
		const jwtServiceEndpoint = {
			baseURL: window.ENV.BENEFICIARY_SERVICE_BASE_URL,
			url: '/hello',
			timeout: 10000,
			method: 'get',
			mode: 'cors',
			headers: {
				Accept: 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET'
			},
			params: {
				name: email
			}
		};
		try {
			return await axios.request(jwtServiceEndpoint);
		} catch (error) {
			if (error.response) {
				return error.response;
			} else {
				return error;
			}
		}
	}
}
